<script lang="ts" setup>
  import { useModal } from '@/stores/modal';

  const modal = useModal();
  const isFullScreen = computed(() => !!modal.state?.isFullScreen);

  function preventScroll(event: Event): void {
    event.preventDefault();
  }

  onMounted(() => {
    document.documentElement.style.overflow = 'hidden';
  });

  onBeforeUnmount(() => {
    document.documentElement.style.overflow = 'auto';
  });
</script>

<template>
  <div
    v-if="modal.isOpen"
    class="modal"
    @scroll="preventScroll"
  >
    <div
      class="modal__content"
      :class="{ 'modal__content--full-screen': isFullScreen }"
    >
      <component
        :is="modal.state.component"
        v-bind="modal.state.props"
        v-on="modal.state.listeners || {}"
      />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
  .modal {
    @apply fixed left-0 top-0;
    @apply h-screen w-screen;
    @apply bg-black bg-opacity-20;
    @apply flex items-center justify-center;
    @apply p-4;
    @apply overflow-hidden;
    @apply rounded-none;
    z-index: 150;
    max-height: 100vh;

    .modal__content {
      @apply w-full;
      @apply max-w-5xl;
      @apply flex items-center justify-center;

      z-index: 200;
      max-height: calc(100vh - 180px);

      @media (min-width: 768px) {
        max-height: calc(100vh - 82px);
      }

      &--full-screen {
        @apply max-w-full;
        @apply h-full;
        @apply max-h-full;
      }
    }
  }
</style>
